import { render, staticRenderFns } from "./ProfitStatement.vue?vue&type=template&id=7fe61c8d&scoped=true"
import script from "./ProfitStatement.vue?vue&type=script&lang=js"
export * from "./ProfitStatement.vue?vue&type=script&lang=js"
import style0 from "./ProfitStatement.vue?vue&type=style&index=0&id=7fe61c8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe61c8d",
  null
  
)

export default component.exports